var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4415 29.3059C58.3966 28.1383 58.3966 27.0156 58.3966 25.9377C58.3966 25.0845 57.723 24.4108 56.8697 24.4108C50.268 24.3659 45.2382 22.4797 41.0616 18.4379C40.4778 17.854 39.4898 17.854 38.9059 18.4379C34.7294 22.4797 29.6995 24.3659 23.1427 24.3659C22.2895 24.3659 21.6158 25.0396 21.6158 25.8928C21.6158 26.9707 21.6158 28.0934 21.5709 29.3059C21.3464 40.3986 21.032 55.533 39.4898 61.9102C39.6694 61.9551 39.8041 62 39.9838 62C40.1634 62 40.343 61.9551 40.4778 61.9102C58.9355 55.533 58.6212 40.3986 58.4415 29.3059Z",
    fill: "#E3E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4413 29.306C58.3964 28.1383 58.3964 27.0156 58.3964 25.9377L25.6436 51.7072C28.2797 55.8905 32.5628 59.517 39.4895 61.9102C39.6692 61.9551 39.8039 62 39.9835 62C40.1632 62 40.3428 61.9551 40.4775 61.9102C58.9353 55.5331 58.6209 40.3986 58.4413 29.306Z",
    fill: "#D2D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2829 34.6502L37.8729 42.0602L34.6843 38.8717C34.1005 38.2878 33.1125 38.2878 32.4838 38.8717C31.8999 39.4555 31.8999 40.4435 32.4838 41.0722L36.7502 45.3386C37.0645 45.653 37.4238 45.7877 37.828 45.7877C38.2322 45.7877 38.6364 45.653 38.9058 45.3386L47.4386 36.8058C48.0224 36.222 48.0224 35.234 47.4386 34.6053C46.8548 34.0214 45.8668 34.0214 45.2829 34.6502Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.52de386e9fb6bc6e81e2ce417adcd113.svg";
export { ForwardRef as ReactComponent };